var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('side-menu'),_c('div',{staticClass:"main-content mt-5"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_vm._t("default")],2)])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }